(ns manage.adset-decision-tree-page.editor.path-panel
  (:require ["@mui/material/Fade$default" :as Fade]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["@xyflow/react" :refer [Panel useOnViewportChange useViewport]]
            ["src/svg/inform/cross.svg$default" :as Cross]
            ["src/svg/path/path.svg$default" :as Path]
            [clojure.string :as str]
            [manage.adset-decision-tree-page.editor.hooks :refer [use-get-is-node-in-viewport]]
            [manage.adset-decision-tree-page.sub :as sub]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-path-panel-label
  [{[root & path] :nodes} get-is-node-in-viewport viewport]
  (let [ascendant-decision-outcome-pairs (butlast (partition-all 2 path))
        parent-reactflow-node-id (:id (or (first (last ascendant-decision-outcome-pairs))
                                          root))]
    (when (and (some? parent-reactflow-node-id)
               (not (get-is-node-in-viewport viewport (str parent-reactflow-node-id))))
      (->> ascendant-decision-outcome-pairs
           (mapv (fn [[{decision-name :name} {outcome-label :label}]]
                   (str decision-name ": " outcome-label)))
           (into ["Starting point"])
           (str/join " / ")))))

(defui ^:memo path-panel-view [{:keys [closed visible-label set-closed]}]
  ($ Panel {:position "top-left"}
     ($ Fade {:in (and visible-label (not closed))}
        ($ Paper {:elevation 2
                  :sx #js {:px 2
                           :py 1
                           :backgroundColor "grey.80"}}
           ($ Stack {:direction "row"
                     :alignItems "center"
                     :sx #js {:maxWidth "40rem"}}
              ($ SvgIcon {:component Path})
              ($ Typography {:sx #js {:direction "rtl"
                                      :textAlign "left"
                                      :textOverflow "ellipsis"
                                      :overflow "hidden"
                                      :whiteSpace "nowrap"
                                      :mx 1}}
                 visible-label)
              ($ IconButton {:onClick #(set-closed true)
                             :edge "end"}
                 ($ SvgIcon {:component Cross})))))))

(defui path-panel []
  (let [selection-path (use-subscribe [::sub/selection-path])
        get-is-node-in-viewport (use-get-is-node-in-viewport)
        get-current-label (uix/use-callback
                           (fn [viewport]
                             (get-path-panel-label selection-path
                                                   get-is-node-in-viewport
                                                   viewport))
                           [get-is-node-in-viewport selection-path])

        [visible-label set-visible-label] (uix/use-state get-current-label)
        [closed set-closed] (uix/use-state false)
        check-path-panel (uix/use-callback
                          (fn [viewport]
                            (if-let [current-label (get-current-label viewport)]
                              (do (set-visible-label current-label)
                                  (set-closed false))
                              (set-closed true)))
                          [get-current-label])
        viewport (useViewport)
        check-path-panel-effect-event (uix/use-effect-event #(check-path-panel viewport))]
    ;; Check path panel label on selection change and viewport change end
    (uix/use-effect #(check-path-panel-effect-event)
                    [selection-path])
    (useOnViewportChange #js {:onEnd check-path-panel})
    ($ path-panel-view {:closed closed
                        :set-closed set-closed
                        :visible-label visible-label})))
